import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { CyberMoviesApp } from './components/CyberMoviesApp';
import { AuthProvider } from './lib/auth';
import { defaultSettings } from './lib/storage';
import './app/globals.css';

const root = document.getElementById('root');

if (!root) throw new Error('Application root element is missing');

createRoot(root).render(
  <StrictMode>
    <AuthProvider apiBase={defaultSettings.apiBase}>
      <CyberMoviesApp />
    </AuthProvider>
  </StrictMode>,
);
